// src/parseAmount.ts
var parseAmount = (value) => {
  if (value === null || value === void 0 || value === "") return void 0;
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : void 0;
};
var parseAmountOr = (value, fallback) => parseAmount(value) ?? fallback;

export {
  parseAmount,
  parseAmountOr
};
